import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import Hero from './components/Hero';
import Intro from './components/Intro';
import UseCaseCards from './components/UseCaseCards';
import ProcessSection from './components/ProcessSection';
import RiggingInfo from './components/RiggingInfo';
import NeedToKnow from './components/NeedToKnow';
import BenefitsStrip from './components/BenefitsStrip';
import BottomCTA from './components/BottomCTA';
import CertificationBanner from '@/components/feature/CertificationBanner';
import { productJsonLd } from '@/components/feature/ProductJsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://popprotents.com';

const jsonLd = productJsonLd({
  name: 'Custom Stretch Tents — Built to Your Specifications | Pop Pro Tents',
  description: 'Design and order custom-built stretch tents tailored to your exact requirements. Perfect for venues, event companies, hospitality brands, and commercial installations. Custom sizes, colours, custom printed skins, and branding available.',
  url: `${siteUrl}/products/custom-stretch-tents`,
  category: 'Custom Stretch Tents',
});

export default function CustomStretchTents() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <CertificationBanner />
        <UseCaseCards />
        <ProcessSection />
        <RiggingInfo />
        <NeedToKnow />
        <BenefitsStrip />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}